import React, { useContext, useState } from "react";
import RedAccordianArrowDown from "../Assets/Images/AccordianArrowDown.svg";
import TealAccordianArrowDown from "../Assets/Images/TealAccordianDown.svg";
import "../Assets/Styles/FAQs.css";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../Hooks/langugaeContext";
const FAQs = ({ bgWhite = true }) => {
  const [openIndex, setOpenIndex] = useState(null);
  const navigate = useNavigate();
  const faqsENG = [
    {
      question: "Why would you need life insurance?",
      answer: `<p class="tracking-normal">Life insurance is essential to help provide financial security to your loved ones or even business continuity in the event of the insured’s death. It could help ensure that a family may continue to maintain their standard of living, and meet financial obligations, such as mortgage payments and college tuition.  Furthermore, life insurance may help relieve your loved ones during a difficult time.  It is a responsible way to help protect your family’s future.</p><p class="mt-4 tracking-normal">Life insurance may not be as complicated or expensive as many people may think. So rather than view it as such, consider what it could mean to your loved ones someday if they lost you — and think of it instead as a potential worry reduced during a difficult situation.</p>`,
    },
    {
      question: "What type of life insurance should you buy?",
      answer: `<p class="tracking-normal">There are two categories of life insurance.  These are term and permanent life insurance, and they each have their advantages.</p><p class="mt-4 tracking-normal">Term life insurance offers pure life insurance protection for a specific period and provides a death benefit for your beneficiary. This policy does not build cash value.</p><p class="mt-4 tracking-normal">Permanent life insurance, such as universal life insurance, offers coverage for life: these policies include cash value that can be accessed during the insured person's lifetime. While permanent life insurance is typically more expensive, it may be the wiser long-term option. Additionally, there is another sub-type of universal life insurance called indexed universal life insurance, the cash value can increase or decrease based on performance of stock market index.</p><p class="mt-4 tracking-normal">Another consideration: The role of your life insurance may change over time, so you may wish to consider a mix of both types of protection.</p>`,
    },
    {
      question: "Will I need flexibility? Will I need cash values?",
      answer: `<p class="tracking-normal">Something to consider in purchasing a life insurance product is whether the policy offers flexibility.  Universal life insurance, a permanent life insurance, grants you more control over your policy details. For example, you can adjust the schedule and amount of your premium payments, and increase or decrease your coverage amount.</p><p class="mt-4 tracking-normal">Like other types of permanent life insurance, a universal life insurance policy can last your entire life and includes a cash value savings component that may build value over time.</p>`,
    },
    {
      question:
        "What should I look for when selecting a good insurance company?",
      answer: `<p class="tracking-normal">Choosing the right insurance company could be crucial to helping provide peace of mind and financial security.  Choose a reputable company that has experience, knows the market, and will have well-trained consultants who can guide you through the process and offer the best coverage options for your needs.  It’s important to research and compare providers to ensure they have a strong financial standing and a solid reputation for customer service.</p>`,
    },
  ];
  const faqsES = [
    {
      question: "¿Por qué necesitaría un seguro de vida?",
      answer: `<p class="tracking-normal">El seguro de vida es esencial para ayudar a brindar seguridad financiera a sus seres queridos o incluso la continuidad del negocio en caso de fallecimiento del asegurado. Podría ayudar a garantizar que una familia pueda seguir manteniendo su nivel de vida y cumplir con sus obligaciones financieras, como los pagos de hipoteca y la matrícula universitaria. Además, el seguro de vida puede ayudar a aliviar a sus seres queridos durante un momento difícil. Es una forma responsable de ayudar a proteger el futuro de su familia.</p>`,
    },
    {
      question: "¿Qué tipo de seguro de vida deberías comprar?",
      answer: `<p class="tracking-normal">Existen dos categorías de seguros de vida. Estos son el seguro de vida temporal y el seguro de vida permanente, y cada uno tiene sus ventajas. El seguro de vida temporal ofrece protección de seguro de vida pura por un período específico y proporciona un beneficio por fallecimiento a su beneficiario. Esta póliza no acumula valor en efectivo. El seguro de vida permanente, como el seguro de vida universal, ofrece cobertura de por vida: estas pólizas incluyen un valor en efectivo al que se puede acceder durante la vida de la persona asegurada. Si bien el seguro de vida permanente suele ser más caro, puede ser la opción más inteligente a largo plazo. Además, existe otro subtipo de seguro de vida universal llamado seguro de vida universal indexado, cuyo valor en efectivo puede aumentar o disminuir según el rendimiento del índice del mercado de valores. Otra consideración: El papel de su seguro de vida puede cambiar con el tiempo, por lo que quizás desee considerar una combinación de ambos tipos de protección.</p>`,
    },
    {
      question: "¿Necesitaré flexibilidad? ¿Necesitaré valores en efectivo?",
      answer: `<p class="tracking-normal">Algo a tener en cuenta a la hora de comprar un producto de seguro de vida es si la póliza ofrece flexibilidad. El seguro de vida universal, un seguro de vida permanente, le otorga más control sobre los detalles de su póliza. Por ejemplo, puede ajustar el cronograma y el monto de los pagos de sus primas, y aumentar o disminuir el monto de su cobertura. Al igual que otros tipos de seguros de vida permanentes, una póliza de seguro de vida universal puede durar toda su vida e incluye un componente de ahorro de valor en efectivo que puede acumular valor con el tiempo.</p>`,
    },
    {
      question: "¿Qué debo buscar al seleccionar una buena compañía de seguros?",
      answer: `<p class="tracking-normal">Elegir la compañía de seguros adecuada podría ser crucial para ayudar a brindar tranquilidad y seguridad financiera. Elija una compañía de buena reputación que tenga experiencia, conozca el mercado y cuente con consultores bien capacitados que puedan guiarlo a través del proceso y ofrecer las mejores opciones de cobertura para sus necesidades. Es importante investigar y comparar proveedores para asegurarse de que tengan una sólida posición financiera y una sólida reputación en el servicio al cliente</p>`,
    },
  ];
  const { language } = useContext(LanguageContext);
  const faqs = language === "Eng" ? faqsENG : faqsES;
  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <div
        id="faqs"
        className={`pb-[4rem] pt-[7rem] lg:pt-[9rem] lg:pb-[7rem]  bg-opacity-70  overflow-x-hidden mainaccordiancontainer ${
          bgWhite ? "bg-[#F7F6F2]" : "bg-[#fdf2d6]"
        }`}
      >
        <div className="container">
          <div className="flex flex-col lg:flex-row gap-8">
            {/* Left Section */}
            <div className="lg:w-1/3 animate__animated animate__fadeInLeft lg:pl-0 pl-4">
              <p className="text-sm text-gray-600 mb-1 learnmoreacc items-baseline ml-1">
                Questions? Answers
              </p>
              <h2 className="text-[26px] md:text-[40px] font-bold mb-2 FAQheading">
                Frequently Asked Questions
              </h2>
              <hr className="bordertitle-line mb-4"></hr>
              <p>
                We answer the main doubts that may arise when purchasing life
                insurance.
              </p>
            </div>

            {/* Right Section */}
            <div className="lg:w-2/3 lg:pl-0 pl-4">
              {faqs.map((faq, index) => (
                <>
                  <div
                    key={index}
                    className={`quesansdivfaq relative animate__animated animate__fadeInRight animate__delay-${index}s border-bottom-neutral`}
                  >
                    <button
                      className="w-full flex items-center justify-between p-4 text-left  group btntostartacc"
                      onClick={() => toggleAccordion(index)}
                    >
                      <span className="font-medium pr-8 text-[14px] lg:text-[18px] md:text-base rightacctextheads">
                        {faq.question}
                      </span>
                      <img
                        src={
                          openIndex !== index
                            ? RedAccordianArrowDown
                            : TealAccordianArrowDown
                        }
                        alt="Accordion Arrow"
                        className={`transition-transform duration-200 ${
                          openIndex === index ? "rotate-180" : ""
                        }`}
                      />
                    </button>

                    <div
                      className={`overflow-hidden transition-max-height duration-300 ease-in-out ${
                        openIndex === index ? "max-h-50" : "max-h-0"
                      }`}
                    >
                      <div className="p-4 pt-0 pb-8">
                        <p
                          className="text-gray-600 text-sm faqAnswers"
                          dangerouslySetInnerHTML={{ __html: faq.answer }}
                        />
                      </div>
                    </div>
                    {faqs.length - 1 === index ? (
                      <></>
                    ) : (
                      <hr className="faq-saperator"></hr>
                    )}
                  </div>
                </>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FAQs;
